import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage title="Cookie Policy">
      <p>
        <strong>Scope</strong>
        <br />
        This policy explains how Tuddlepetgoods uses cookies, local storage, and
        similar browser technologies on this storefront. These technologies can
        remember information on a device or help a service receive information
        about a browser session.
      </p>
      <p>
        <strong>Local storage used by the storefront</strong>
        <br />
        The storefront saves shopping-cart selections in your browser&apos;s local
        storage so the cart remains available while you browse and when you
        return using the same browser. The stored cart may include product
        identifiers, quantity, size, and color. It remains on the device until
        the cart is cleared, site data is removed, or the browser removes it.
      </p>
      <p>
        <strong>Strictly necessary technologies</strong>
        <br />
        Hosting, security, payment, and delivery providers may use cookies or
        similar technologies that are necessary to load services, maintain a
        session, balance traffic, prevent fraud, remember security choices, and
        complete a transaction. Blocking them may prevent checkout or another
        requested function from working.
      </p>
      <p>
        <strong>Payment-provider technologies</strong>
        <br />
        When you proceed to hosted checkout, the payment provider may place or
        read its own cookies for authentication, fraud screening, security, and
        payment processing. Those technologies are controlled by the provider
        and described in its own notices.
      </p>
      <p>
        <strong>Analytics and advertising</strong>
        <br />
        We do not currently place our own analytics or targeted-advertising
        cookies through this storefront. If we introduce non-essential cookies,
        we will update this policy and provide consent controls before use where
        applicable law requires them.
      </p>
      <p>
        <strong>Your controls</strong>
        <br />
        Browser or device settings can block cookies, delete local storage, and
        remove site data. Controls vary by browser. Clearing local storage will
        remove the saved cart on that browser. Privacy or content-blocking tools
        may also affect hosted checkout and other third-party services.
      </p>
      <p>
        <strong>Do Not Track and Global Privacy Control</strong>
        <br />
        Because this storefront does not currently use cross-context behavioral
        advertising, it does not respond differently to Do Not Track signals.
        Where a legally recognized opt-out signal applies to a future practice,
        we will honor it as required and update this notice.
      </p>
      <p>
        <strong>Privacy information and contact</strong>
        <br />
        See our <Link to="/privacy">Privacy Policy</Link> and{" "}
        <Link to="/privacy-choices">Privacy Choices</Link> for other personal
        information practices. Cookie questions can be sent to <SupportEmail />.
      </p>
    </PolicyPage>
  );
}

export default CookiePolicy;
